export const CACHE_UPLOADS = 'CACHE_UPLOADS';
export const SET_CC_TYPE = 'SET_CC_TYPE';
export const UPLOADING_FILES = 'UPLOADING_FILES';
